import React, { JSX, useEffect, useRef, useState } from 'react';

interface InputTextProps {
  autofocus?: boolean;
  labelTitle?: string;
  labelStyle?: string;
  type?: string;
  className?: string;
  containerStyle?: string;
  defaultValue?: string;
  placeholder?: string;
  updateFormValue: (updateType: string, value: string) => void; // Updated function signature
  updateType: string;
  hideArrows?: boolean;
  max?: number;
  min?: number;
  minLength?: number;
  maxLength?: number;
  icon?: JSX.Element;
  iconPosition?: 'start' | 'end';
  pattern?: string;
}

function InputText({
  autofocus,
  labelTitle,
  labelStyle,
  type,
  containerStyle,
  className = '',
  defaultValue,
  placeholder,
  updateFormValue,
  updateType,
  hideArrows,
  minLength,
  maxLength,
  min,
  max,
  icon,
  iconPosition = 'start',
  pattern,
}: InputTextProps): JSX.Element {
  const [value, setValue] = useState<string>(defaultValue || '');
  const inputRef = useRef<HTMLDivElement | null>(null);

  const updateInputValue = (val: string): void => {
    setValue(val);
    updateFormValue(updateType, val); // Pass both updateType and value
  };

  return (
    <div ref={inputRef} className={`form-control w-full ${containerStyle}`}>
      <fieldset className="fieldset">
        {labelTitle && (
          <legend className="fieldset-legend">{labelTitle}</legend>
        )}
        {icon && iconPosition === 'start' && (
          <span className="input-icon">{icon}</span>
        )}
        <input
          type={type || 'text'}
          value={value}
          placeholder={placeholder || ''}
          onChange={(e) => updateInputValue(e.target.value)}
          minLength={minLength}
          maxLength={maxLength}
          className={`input input-bordered w-full ${
            hideArrows
              ? '[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none'
              : ''
          } ${className}`}
          autoFocus={autofocus}
          min={min}
          max={max}
          pattern={pattern}
        />
        {icon && iconPosition === 'end' && (
          <span className="input-icon">{icon}</span>
        )}
        {/* Uncomment if you want to show optional label */}
        {/* <p className="fieldset-label">Optional</p> */}
      </fieldset>
    </div>
  );
}

export default InputText;
